import BaseBlockMap from './BaseBlockMap';
import InsuranceBlockMap from './InsuranceBlockMap';


export default {
    ...BaseBlockMap,
    ...InsuranceBlockMap,
};
